<template>
  <div class="warning">
    <img
      src="~@/images/form/bingeDrinkerWarning/icon-binge-warning.svg"
      alt=""
    />
    <p>
      {{ dictionary[DictionaryField.DCC_RESULTS_BINGEDRINKWARNING] }}
    </p>
  </div>
</template>

<script>
import { createComponent } from "@vue/composition-api";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

export default createComponent({
  setup() {
    const dictionary = useDictionary();
    return {
      ...dictionary,
    };
  },
});
</script>

<style lang="scss" scoped></style>
